import { memo, useEffect } from 'react'

import { getResponseErrorCode } from '@surglogs-app/error'
import { getPaymentRequiredRoute } from '@surglogs-app/routing'

export interface PaymentRequiredErrorScreenProps {
  error: unknown
}

export const PaymentRequiredErrorScreen = memo(
  ({ error }: PaymentRequiredErrorScreenProps) => {
    useEffect(() => {
      window.location.href = getPaymentRequiredRoute(
        getResponseErrorCode(error),
      )
    }, [error])

    return null
  },
)
